import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import LoginView from '@/components/views/LoginView.vue'
import RequestPasswordChange from '@/components/views/RequestPasswordChange.vue'
import CreateNewPassword from '@/components/views/CreateNewPassword.vue'
import HomeView from '@/components/views/HomeView.vue'
import AccountView from '@/components/views/AccountView.vue'
import ClaimsListView from '@/components/views/ClaimsListView.vue'
import ReaffirmTerms from '@/components/views/ReaffirmTerms.vue'
import ClaimView from '@/components/claimdetails/ClaimView.vue'

import ClaimStatusTab from '@/components/claimdetails/ClaimStatusTab.vue'
import ClaimBerichtTab from '@/components/claimdetails/ClaimBerichtTab.vue'
import ClaimDetailsTab from '@/components/claimdetails/ClaimDetailsTab.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  },
  {
    path: '/internal/:contactid/:internaluser',
    name: 'internallogin',
    component: LoginView
  },
  {
    path: '/logout',
    name: 'logout',
    component: LoginView
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: RequestPasswordChange
  },
  {
    path: '/forgot/:expired',
    name: 'forgotex',
    component: RequestPasswordChange
  },
  {
    path: '/newpassword/:requestid',
    name: 'newpassword',
    component: CreateNewPassword
  },
  {
    path: '/reaffirm',
    name: 'reaffirm',
    component: ReaffirmTerms
  },
  {
    path: '/home',
    component: HomeView,

    children: [
      {
        path: '/home/claims',
        name: 'claims',
        component: ClaimsListView
      },
      {
        path: '/home/managedclaims',
        name: 'managedclaims',
        component: ClaimsListView
      },
      {
        path: '/home/account',
        name: 'account',
        component: AccountView
      }]
  },
  {
    path: '/claim/:claimid',
    name: 'claim',
    component: ClaimView,

    children: [{
      path: '/claim/:claimid/status/:anchor?',
      name: 'status',
      component: ClaimStatusTab
    },
    {
      path: '/claim/:claimid/details',
      name: 'details',
      component: ClaimDetailsTab
    },
    {
      path: '/claim/:claimid/bericht',
      name: 'bericht',
      component: ClaimBerichtTab
    }]
  }
]

const router = new VueRouter({
  routes
})

const ALLOWED_ROUTES = ['login', 'internallogin', 'forgot', 'forgotex', 'newpassword', 'logout']
router.beforeEach((to, from, next) => {
  const loggedIn = store.getters.getLogin
  const disclaimer = store.getters.getDisclaimerState
  if (ALLOWED_ROUTES.indexOf(to.name) > -1) {
    if (loggedIn) {
      next()
    } else {
      store.dispatch('checkLogin').then((result) => {
        if (result.loggedIn) {
          next(to.path)
        } else {
          next()
        }
      })
    }
  } else {
    if (disclaimer && to.path !== '/reaffirm') {
      next('/reaffirm')
    }
    if (loggedIn) {
      next()
    } else {
      store.dispatch('checkLogin').then((result) => {
        if (result.loggedIn) {
          next()
        } else {
          store.dispatch('setPostLoginRedirect', to.path)
          next('/')
        }
      })
    }
  }
})

export default router
